export default "__VITE_ASSET__C2lm2gqJ__"